import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {useHistory, useLocation} from 'react-router-dom';

import {
  updateSearchTerm,
} from '../../modules/betaOpportunities';
import { toggleBrowseMenu } from '../../modules/app';
import SearchInput from './searchInput';

const DiscoverSearch = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const loadingOpportunities = useSelector(state => state.betaOpportunities.loadingOpportunities);
  const searchTerm = useSelector(state => state.betaOpportunities.searchTerm);

  const handleSearchChange = event => {
    if (location.pathname !== '/discover') {
      history.push('/discover');
    }
    dispatch(toggleBrowseMenu(false));
    dispatch(updateSearchTerm(event.target.value || ''));
  }

  const clearSearch = () => {
    dispatch(updateSearchTerm(''));
  }

  return (
    <>
      <SearchInput
        loading={loadingOpportunities}
        value={searchTerm}
        placeholder={t('DiscoverSearch')}
        onChange={handleSearchChange}
        onClose={clearSearch}
      />
    </>
  );
}

export default DiscoverSearch;
